import React, { useState } from "react";
import {
  makeStyles,
  Container,
  Modal,
  Grid,
  Typography,
  TextField,
} from "@material-ui/core";
import { ITheme } from "../constants/theme";
import { CancelButton, SubmitButton } from '../components-atoms';

export const NumberOfPackageSelectionModal = (props: any) => {
  const classes = useStyles();
  const [numberOfPackages, setNumberOfPackages] = useState("");
  return (
    <Modal
      open={props.visible}
      onClose={props.onClose}
      aria-labelledby="Number of packages"
      className={classes.modal}
    >
      <Container className={classes.modalContainer}>
        <Grid container spacing={1}>
          <Grid item>
            <Typography variant="h6" component="h6" color="textPrimary">
              Number of packages
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2" component="p" color="textPrimary">
              Mark number of packages this order has been packed into. This
              determines how many labels are required before handing the order to
              the courier.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={numberOfPackages}
              onChange={(e) => {
                if (e.target.value !== '' && +e.target.value < 1) {
                  return;
                } setNumberOfPackages(e.target.value);
              }}
              variant="outlined"
              margin="normal"
              fullWidth
              id="nrOfPackages"
              label="Nr. of packages"
              name="Nr. of packages"
              type="number"
              autoFocus
              InputProps={{
                classes: {
                  root: classes.cssOutlinedInput,
                  focused: classes.cssFocused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
            />
          </Grid>
          <Grid item container xs={12} justifyContent="flex-end">
            <CancelButton onClick={props.onClose} />
            <SubmitButton disabled={!!!numberOfPackages} onClick={() => props.onSubmit(parseInt(numberOfPackages))} />
          </Grid>
        </Grid>
      </Container>
    </Modal>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  modal: { alignItems: "center", justifyContent: "center" },
  modalContainer: {
    width: "480px",
    height: "274px",
    backgroundColor: "white",
    boxShadow:
      "0px 6px 36px rgba(0, 0, 0, 0.15), 0px 2.21728px 14.2392px rgba(0, 0, 0, 0.111884), 0px 0.93179px 6.99399px rgba(0, 0, 0, 0.0997219), 0px 0.37078px 3.36556px rgba(0, 0, 0, 0.0894965), 0px 0.120827px 1.42249px rgba(0, 0, 0, 0.0753326), 0px 0.0225271px 0.422798px rgba(0, 0, 0, 0.0508791)",
    borderRadius: "20px",
    padding: "24px",
    margin: "0",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
}));
